import React, { useState } from 'react'
import { useEffect } from 'react';
import { Modal } from "react-bootstrap";

const RoomFilterPopUp = (props) => {
    const [showModal, setShowModal] = useState(true);
    const [inlineRoom, setInlineRoom] = useState([]);
    const [RoomFilterData, setRoomFilterData] = useState([]);
    

    let roomcount = '';
    let inlineRoomList = [];
    const handleDeleteFilterRoom = (item, e) => {
        const newList = inlineRoomList.filter((data) => data.id.i !== item);
        inlineRoomList = newList;
        setInlineRoom(newList);
        CustomizeRoom(item - 1);
    }
    const CustomizeRoom = async (rooms) => {
        let html = [];
        let inlinedata = [];
        for (let i = 1; i <= rooms; i++) {
            html.push(
                {
                    id: { i }, html:
                        <div className="d-flex d-flex align-items-end" id={"divmain" + i} key={i}>
                            <div className="flex-fill mx-1">
                                <div className="form-group">
                                    <label className="wl-label"> Room {i}</label>
                                </div>
                            </div>
                            <div className="flex-fill mx-1">
                                <div className="form-group">
                                    <label className="wl-label">Adults</label>
                                    <select className={`form-control adult${i}`} >
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </div>
                            </div>
                            <div className="flex-fill mx-1">
                                <div className="form-group">
                                    <label className="wl-label">Child </label>
                                    <select className={`form-control child${i}`} >
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                    </select>
                                </div>
                            </div>
                            <div className="flex-fill mx-1">
                                <div className="form-group">
                                    <label className="wl-label">Extra Bed</label>
                                    <select className={`form-control extraBed${i}`} >
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                    </select>
                                </div>
                            </div> 
                            <div className="flex-fill mx-1">
                                <div className="form-group">
                                    <label className={`wl-label ml-2 ${i == rooms ? (rooms !== 1 ? 'visible' : 'invisible') : 'invisible'} cursor-pointer`}>
                                        <a onClick={() => handleDeleteFilterRoom(i)}>
                                            <img src="/images/delete-icon.svg" alt="" />
                                        </a>
                                    </label>
                                </div>
                            </div>
                        </div>
                })
        }
        inlineRoomList = html;
        setInlineRoom(html);
    }
    const handleRooms = (e) => {
        CustomizeRoom(e.target.value);
        roomcount = e.target.value;
    }
    const handleClose = () => {
        setShowModal(false);
        props.showPopUp(false);
    }

    const handleSearch = () => {
        const totalroomNo = document.getElementsByClassName('TotalRoomNo')[0].value;
        let inlineRoomData = [];
        for (let i = 1; i <= totalroomNo; i++) {
            var adult = document.getElementsByClassName("adult" + i)[0].value;
            var child = document.getElementsByClassName("child" + i)[0].value;
            var extraBed = document.getElementsByClassName("extraBed" + i)[0].value;
            inlineRoomData.push({ Key: i, Adult: adult, Child: child, ExtraBed: extraBed })
        }
        setRoomFilterData(inlineRoomData);
        props.searchroom(inlineRoomData, totalroomNo);
    }
    useEffect(() => {
        const load = async () => {
            await CustomizeRoom(props.filterdata.length > 0 ? props.filterdata.length : 1)
            setTimeout(() => {
                if (props.filterdata.length > 0) {
                    for (let i = 0; i < props.filterdata.length; i++) {
                        document.getElementsByClassName("adult" + props.filterdata[i].Key)[0].value = props.filterdata[i].Adult
                        document.getElementsByClassName("child" + props.filterdata[i].Key)[0].value = props.filterdata[i].Child
                        document.getElementsByClassName("extraBed" + props.filterdata[i].Key)[0].value = props.filterdata[i].ExtraBed
                    }
                }
            }, 100);
        }
        load();
    }, [])


    console.log(inlineRoom)
    return (
        <>
            <Modal
                show={showModal}
                onHide={handleClose}
                animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5 id="exampleModalLabel">Rooms & Guests</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row wl-gutters-5">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="wl-label"> Number of Rooms</label>
                                <select className="form-control TotalRoomNo" value={inlineRoom.length} onChange={handleRooms}>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {inlineRoom.map(
                        (item) => (item.html)
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-dark" onClick={handleClose}>Cancel</button>
                    <button type="button" className="btn btn-primary" onClick={handleSearch}>Search</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RoomFilterPopUp